<template>
  <div class="wuxing">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    const info = localStorage.getItem('judge_info')
    if (to.name !== 'wuxing_login') {
      if (!info) {
        next({ name: 'wuxing_login', query: to.query })
      } else {
        next()
      }
    } else {
      if (info) {
        next({ name: 'wuxing_judge', query: to.query })
      } else {
        next()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'tplogin' || to.name == 'login') {
      next({ name: 'wuxing_login', query: from.query })
    } else {
      next()
    }
  },
  data() {
    return {}
  },
}
</script>
